import { Table } from '@molecules';
import { Typography } from '@mui/material';
import { getSubCategoriesColumns, ReportItem } from './subCategoryTable.config';
import { useParams } from 'react-router-dom';
import { ApiClientEnterprise } from '@helpers/apiClients';

const TopReportedProblemsModal = () => {
  const { id: organizationId } = useParams<{ id: string }>();

  const _formatData = (data?: ReportItem[]) => {
    if (!data) {
      return { items: [], totalCount: 0 };
    }

    const reducedData = data.reduce((acc, curr) => {
      const key = `${curr.category}-${curr.subCategory}`;
      const existing = acc.find((item) => `${item.category}-${item.subCategory}` === key);

      if (existing) {
        existing.reportcount += curr.reportcount;
        existing.uuids = [...new Set([...existing.uuids, ...curr.uuids])];
      } else {
        acc.push({ ...curr });
      }

      return acc;
    }, [] as ReportItem[]);

    return { items: reducedData, totalCount: reducedData.length };
  };

  const _getRowId = (row: ReportItem) => `${row.category}-${row.subCategory}`;

  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb="5px" p={3} pb={0}>
        Top Reported Problems
      </Typography>
      <Table<ReportItem>
        sx={{ padding: 3 }}
        searchPlaceholder="Search for News"
        columns={getSubCategoriesColumns()}
        apiClient={ApiClientEnterprise}
        apiRoute={`/enterprises-admin/${organizationId}/sentiment-analysis/top-reported-problem`}
        defaultQueries={{ page: undefined, size: undefined }}
        defaultPageSize={-1}
        formatData={_formatData}
        getRowId={_getRowId}
        withoutSearch
        checkHidePagination
        hideFooterSelectedRowCount
        hideFooter
        autoHeight
      />
    </>
  );
};

export default TopReportedProblemsModal;
